import ReadyForInvoicingTpJobItem from './ReadyForInvoicingTpJobItem';
import TpJobItem from './TpJobItem';

export default class ClientReadyForInvoicingTpJobItem extends ReadyForInvoicingTpJobItem {
  static FieldsToShowInDataTable() {
    const fields = ReadyForInvoicingTpJobItem.FieldsToShowInDataTable();
    const sourceIndex = fields.findIndex((f) => f.orderById === 'ThirdPartySource');
    fields.splice(sourceIndex + 1, 0, {
      label: 'Project',
      orderById: 'ProjectNameAndId',
      data: TpJobItem.getProjectCellContent,
      minWidth: 150,
    });
    return fields;
  }
}
